module.exports = __webpack_public_path__ + "img/ic-cover.478b0694.jpg";